export default {
  loading: false,
  error: false,
  uploadLoading: false,
  groupId: null,
  configurations: null,
  idConfigurationVideo: null
}
